export const OPERATOR_ROUTES_LIST = 'operator-routes-list'